(ns teamoesterreich.admin-mode.event-alarm.detail.alarm-message
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [clojure.string :as str]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.ui-helper.sms-block-edit-card :as sms-block-edit-card]
            [teamoesterreich.admin-mode.ui-helper.email-block-edit-card :as edit-email-card]
            [teamoesterreich.admin-mode.ui-helper.push-block-edit-card :as edit-push-card]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.eventAlarm :as d-eventAlarm]
            [teamoesterreich.util.markdown :refer [md]]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]

            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.send :refer [send]]
            ))



(defn get-alarmMessage-sms [!actual-alarm !event-detail-loaded? disabled] ;; push/SMS
  (let [!st (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !user-devices (r/cursor store/app-state [:user-devices])
        !show-send-me (r/cursor !st [:show-send-me])
        !su-edit (r/cursor !st [:su-edit])
        ]
    (fn []
      (log/debug "user smsText" @!user-devices)
      (let [save-fn (fn [text]
                      (d-eventAlarm/>alarm-save (:eventAlarm-uuid @!actual-alarm) {:eventAlarm-smsText text}
                                                (fn [data]
                                                  (reset! !actual-alarm data)
                                                  (reset! !event-detail-loaded? nil)
                                                  )))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me
          "Möchtest du diese Anfrage-SMS testweise an dich senden ?" "Senden"
          (fn [] (d-eventAlarm/>alarm-send-test-sms (:eventAlarm-uuid @!actual-alarm) (:tom-id @!actual-user)))]

         (if disabled
           [:div {:style {:border "1px dotted darkgrey" :padding "10px" :maxWidth "800px"}}
            [mui/card-header {:title "Anfragen SMS"}]
            [:div (get @!actual-alarm :eventAlarm-smsText)]
            [:br]
            [:br]
            (when (and disabled (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE (:eventAlarm-orgId @!actual-alarm)))
              [mui/button {
                           :variant   "outlined"
                           :style     {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])]
           [:div
            [mui/card-header {:title "Anfragen SMS "}]
            [(sms-block-edit-card/get-it (get @!actual-alarm :eventAlarm-smsText)
                                         save-fn
                                         {:titel              "Anfrage (SMS)"
                                          :template-group     "event"
                                          :subText            (r/as-element
                                                                [:p
                                                                 "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#"
                                                                 ])
                                          :additional-buttons [:div
                                                               [mui/button {
                                                                            :variant   "contained"
                                                                            :color     "secondary"
                                                                            :startIcon (r/as-element [send])
                                                                            :onClick   #(reset! !show-send-me true)
                                                                            } "An mich per SMS"]]
                                          :on-cancel-fn       on-cancel-fn
                                          })]])

         ]
        ))))


(defn get-alarmMessage-push [!actual-alarm !event-detail-loaded? disabled] ;; push/SMS
  (let [!st (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !user-devices (r/cursor store/app-state [:user-devices])
        !show-send-me-push (r/cursor !st [:show-send-me-push])
        !show-send-me (r/cursor !st [:show-send-me])
        !su-edit (r/cursor !st [:su-edit])
        ]
    (fn []
      (log/debug "user smsText" @!user-devices)
      (let [save-fn (fn [text]
                      (d-eventAlarm/>alarm-save (:eventAlarm-uuid @!actual-alarm) {:eventAlarm-pushText text}
                                                (fn [data]
                                                  (reset! !actual-alarm data)
                                                  (reset! !event-detail-loaded? nil)
                                                  )))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me-push
          "Möchtest du diesen Anfrage-Push testweise an dich senden ?" "Senden"
          (fn [] (d-eventAlarm/>alarm-send-test-push (:eventAlarm-uuid @!actual-alarm) (:tom-id @!actual-user)))]


         (if disabled
           [:div {:style {:border "1px dotted darkgrey" :padding "10px" :maxWidth "800px"}}
            [mui/card-header {:title "Anfragen Push"}]
            [:div (get @!actual-alarm :eventAlarm-pushText)]
            [:br]
            [:br]
            (when (and disabled (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE (:eventAlarm-orgId @!actual-alarm)))
              [mui/button {
                           :variant   "outlined"
                           :style     {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])]
           [:div
            [mui/card-header {:title "Anfragen Push"}]
            [(edit-push-card/get-it (get @!actual-alarm :eventAlarm-pushText)
                                    save-fn
                                    {:titel              "Anfrage (Push)"
                                     :template-group     "event"
                                     :subText            (r/as-element
                                                           [:p
                                                            "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#"
                                                            ])
                                     :additional-buttons [:div
                                                          [mui/button {
                                                                       :style     {:marginLeft "10px"}
                                                                       :variant   "contained"
                                                                       :color     "secondary"
                                                                       :startIcon (r/as-element [send])
                                                                       :onClick   #(reset! !show-send-me-push true)
                                                                       } "An mich per Push"]]
                                     :on-cancel-fn       on-cancel-fn
                                     })]])

         ]
        ))))

(defn get-alarmMessage-email [!actual-alarm !event-detail-loaded? disabled]
  (let [!state (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !show-send-me (r/cursor !state [:show-send-me])
        !su-edit (r/cursor !state [:su-edit])]
    (fn []
      (let [has-edit-right false
            save-email-fn (fn [subject body] (d-eventAlarm/>alarm-save (:eventAlarm-uuid @!actual-alarm) {:eventAlarm-mailSubject (str subject)
                                                                                                          :eventAlarm-mailBody    (str body)}
                                                                       (fn [data]
                                                                         (reset! !actual-alarm data)
                                                                         (reset! !event-detail-loaded? nil)
                                                                         )))]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me
          "Möchtest du diese Alarmierung Email testweise an dich senden ?" "Senden"
          (fn [] (d-eventAlarm/>alarm-send-test-email (:eventAlarm-uuid @!actual-alarm) (:tom-id @!actual-user)))]
         [:div
          (if disabled
            [:div
             [mui/card-header {:title "Email Inhalt"}]
             [:div "Betreff: " (get @!actual-alarm :eventAlarm-mailSubject)]
             [:br]
             [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!actual-alarm :eventAlarm-mailBody) ""))}
                    :className               "editor-preview-widget"
                    :style                   {:minWidth "800px" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "200px" :padding "10px" :border "1px dotted grey"}}]
             [:br]
             [:br]
             (when (and disabled (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE (:eventAlarm-orgId @!actual-alarm)))
               [mui/button {
                            :variant   "outlined"
                            :style     {:color "orange"}
                            :startIcon (r/as-element [edit])
                            :onClick   #(reset! !su-edit true)
                            } "Bearbeiten (superuser)"])]


            [(edit-email-card/get-it
               (get @!actual-alarm :eventAlarm-mailSubject)
               (get @!actual-alarm :eventAlarm-mailBody)
               save-email-fn
               {:title             "Email "
                :template-group    "training"
                :template-type     "email"
                :subText           "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#"
                :additional-button [mui/button {
                                                :variant   "contained"
                                                :color     "secondary"
                                                :startIcon (r/as-element [send])
                                                :onClick   #(reset! !show-send-me true)
                                                } "An mich senden"]})]
            )
          ]
         ]))))